import { createSvgIcon } from "@mui/material";

export const HomeIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.14373 18.7821V15.7152C7.14372 14.9381 7.77567 14.3067 8.55844 14.3018H11.4326C12.2189 14.3018 12.8563 14.9346 12.8563 15.7152V18.7732C12.8562 19.4473 13.404 19.9951 14.0829 20H16.0438C16.9596 20.0023 17.8388 19.6428 18.4872 19.0007C19.1356 18.3586 19.5 17.4868 19.5 16.5775V7.86585C19.5 7.13139 19.1721 6.43471 18.6046 5.9635L11.943 0.674268C10.7785 -0.250877 9.11537 -0.220992 7.98539 0.745384L1.46701 5.9635C0.872741 6.42082 0.517552 7.11956 0.5 7.86585V16.5686C0.5 18.4637 2.04738 20 3.95617 20H5.87229C6.19917 20.0023 6.51349 19.8751 6.74547 19.6464C6.97746 19.4178 7.10793 19.1067 7.10792 18.7821H7.14373Z" />
  </svg>,
  "Home"
);

export const CartIcon = createSvgIcon(
  <svg
    width="19"
    height="20"
    viewBox="0 0 19 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.55222 7.36865C0.999931 7.36865 0.552216 7.81637 0.552216 8.36865V17.0002C0.552216 18.6571 1.89536 20.0002 3.55221 20.0002H15.4478C17.1046 20.0002 18.4478 18.6571 18.4478 17.0002V8.36865C18.4478 7.81637 18.0001 7.36865 17.4478 7.36865H1.55222ZM11.6057 13.6842C11.6057 14.8469 10.6631 15.7895 9.50042 15.7895C8.33771 15.7895 7.39516 14.8469 7.39516 13.6842C7.39516 12.5215 8.33771 11.5789 9.50042 11.5789C10.6631 11.5789 11.6057 12.5215 11.6057 13.6842Z"
    />
    <path
      opacity="0.3"
      d="M9.50042 2.69689L5.04591 8.0423C4.67374 8.48891 4.00999 8.54925 3.56338 8.17708C3.11677 7.8049 3.05643 7.14115 3.4286 6.69454L8.69176 0.378753C9.1126 -0.126251 9.88823 -0.126251 10.3091 0.378753L15.5722 6.69454C15.9444 7.14115 15.8841 7.8049 15.4375 8.17708C14.9908 8.54925 14.3271 8.48891 13.9549 8.0423L9.50042 2.69689Z"
    />
  </svg>,
  "Cart"
);

export const StoreIcon = createSvgIcon(
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" width="20" height="20" rx="5" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.66806 11.5548C4.3617 11.0953 4.48588 10.4744 4.94541 10.1681C5.40493 9.8617 6.0258 9.98588 6.33216 10.4454C7.48919 12.181 8.85444 13.0001 10.5001 13.0001C12.1458 13.0001 13.511 12.181 14.6681 10.4454C14.9744 9.98588 15.5953 9.8617 16.0548 10.1681C16.5143 10.4744 16.6385 11.0953 16.3322 11.5548C14.8225 13.8193 12.8544 15.0001 10.5001 15.0001C8.14578 15.0001 6.17769 13.8193 4.66806 11.5548Z"
      fill="#515151"
    />
  </svg>,
  "Store"
);

export const ProfileIcon = createSvgIcon(
  <svg
    width="17"
    height="20"
    viewBox="0 0 17 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.50001 13.1748C4.18701 13.1748 0.503006 13.8548 0.503006 16.5748C0.503006 19.2958 4.16401 19.9998 8.50001 19.9998C12.813 19.9998 16.497 19.3208 16.497 16.5998C16.497 13.8788 12.837 13.1748 8.50001 13.1748Z" />
    <path
      opacity="0.4"
      d="M8.50001 10.584C11.438 10.584 13.792 8.229 13.792 5.292C13.792 2.355 11.438 0 8.50001 0C5.56301 0 3.20801 2.355 3.20801 5.292C3.20801 8.229 5.56301 10.584 8.50001 10.584Z"
    />
  </svg>,

  "Profile"
);

export const OrdersIconBottomNavIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 24 24"
  >
    <rect width="24" height="24" fill="none" />
    <path d="M4 20V7.1L2.05 2.85L3.85 2L6.2 7.05h11.6L20.15 2l1.8.85L20 7.1V20zm6-7h4q.425 0 .713-.288T15 12q0-.425-.288-.712T14 11h-4q-.425 0-.712.288T9 12q0 .425.288.713T10 13" />
  </svg>,
  "OrdersBottomNav"
);

export const TermsIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
    <polyline points="14 2 14 8 20 8"></polyline>
    <line x1="16" y1="13" x2="8" y2="13"></line>
    <line x1="16" y1="17" x2="8" y2="17"></line>
    <polyline points="10 9 9 9 8 9"></polyline>
  </svg>,

  "Terms"
);

export const PhoneIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
  </svg>,

  "Phone"
);

export const OrderIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="img"
    font-size="2rem"
    class="iconify iconify--tabler"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
  >
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M16.7 8A3 3 0 0 0 14 6h-4a3 3 0 0 0 0 6h4a3 3 0 0 1 0 6h-4a3 3 0 0 1-2.7-2M12 3v3m0 12v3"
    ></path>
  </svg>,
  "Orderss"
);

export const LogoutIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="img"
    font-size="1.375rem"
    class="iconify iconify--tabler"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
  >
    <g
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    >
      <path d="M14 8V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2v-2"></path>
      <path d="M9 12h12l-3-3m0 6l3-3"></path>
    </g>
  </svg>,

  "Logout"
);
